// Wordmark — custom-drawn, NOT the Inter Tight default. A solid, financial-feeling mark.
// Ported from yeni-design/src/shell.jsx (lines 4-25).

type WordmarkSize = 'sm' | 'md' | 'lg';

interface WordmarkProps {
  size?: WordmarkSize;
  className?: string;
}

export function Wordmark({ size = 'md', className = '' }: WordmarkProps) {
  const sizes: Record<WordmarkSize, { mark: number; text: string }> = {
    sm: { mark: 18, text: 'text-[14px]' },
    md: { mark: 22, text: 'text-[16px]' },
    lg: { mark: 28, text: 'text-[22px]' },
  };
  const s = sizes[size];
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      {/* mark: stylized double-bar / report glyph */}
      <svg width={s.mark} height={s.mark} viewBox="0 0 24 24" aria-hidden="true">
        <rect x="2" y="2" width="20" height="20" rx="4" fill="#1e40af" />
        <rect x="6" y="13" width="2.5" height="6" rx="0.5" fill="#fff" />
        <rect x="10.75" y="9" width="2.5" height="10" rx="0.5" fill="#fff" />
        <rect x="15.5" y="5" width="2.5" height="14" rx="0.5" fill="#fff" />
      </svg>
      <span className={`${s.text} font-semibold tracking-tight text-ink-900`}>
        Rapor<span className="text-brand-700">Gör</span>
      </span>
    </div>
  );
}
